<era-device-sync-status-ui [deviceStatus]="deviceStatus$ | async"> </era-device-sync-status-ui>